import { BaseService } from './BaseService';
import apiClient from './apiClient';
import { Product, CreateProductRequest, ApiResponse } from './types';

export class ProductService extends BaseService<
  Product,
  CreateProductRequest,
  Partial<CreateProductRequest>
> {
  constructor() {
    super('/products');
  }

  // Get products by category
  async getByCategory(category: string): Promise<Product[]> {
    const response = await apiClient.get<ApiResponse<Product[]>>(
      `${this.endpoint}/category/${category}`
    );
    return response.data.data;
  }

  // Get featured products
  async getFeatured(): Promise<Product[]> {
    const response = await apiClient.get<ApiResponse<Product[]>>(
      `${this.endpoint}/featured`
    );
    return response.data.data;
  }

  // Update product stock
  async updateStock(id: string, quantity: number): Promise<Product> {
    const response = await apiClient.patch<ApiResponse<Product>>(
      `${this.endpoint}/${id}/stock`,
      { quantity }
    );
    return response.data.data;
  }

  // Toggle product availability
  async toggleAvailability(id: string): Promise<Product> {
    const response = await apiClient.patch<ApiResponse<Product>>(
      `${this.endpoint}/${id}/toggle-availability`
    );
    return response.data.data;
  }

  // Search products with filters
  async searchWithFilters(filters: {
    query?: string;
    category?: string;
    minPrice?: number;
    maxPrice?: number;
    inStock?: boolean;
  }): Promise<Product[]> {
    const response = await apiClient.get<ApiResponse<Product[]>>(
      `${this.endpoint}/search`,
      { params: filters }
    );
    return response.data.data;
  }
}

// Create singleton instance
export const productService = new ProductService();
